<template>
  <div id="content">
    <div class="source-container">
      <img
        class="image"
        :src="currentSource.url"
        v-if="currentSource.type === 1"
      />
      <video
        class="image"
        :src="currentSource.url"
        v-if="currentSource.type === 2"
        autoplay
        controls
      />
    </div>
    <div class="button-container">
      <button v-if="showPre" @click="onPre">上一页</button>
      <button v-if="showNext" @click="onNext">下一页</button>
    </div>
  </div>
</template>

<script>
const allVideoImages = [
  {
    type: 1,
    url:
      'http://content-pic2-mirror.oss-cn-hangzhou.aliyuncs.com/1719883097807.png',
  },
  {
    type: 1,
    url:
      'http://content-pic2-mirror.oss-cn-hangzhou.aliyuncs.com/1720082384955.png',
  },
  {
    type: 1,
    url:
      'http://content-pic2-mirror.oss-cn-hangzhou.aliyuncs.com/1719884320791.png',
  },
  {
    type: 1,
    url:
      'http://content-pic2-mirror.oss-cn-hangzhou.aliyuncs.com/1719884398276.png',
  },
  {
    type: 2,
    url:
      'https://mpv.videocc.net/722a1e202d/5/722a1e202dc924d8914f5687c4e8a7a5_3.mp4',
  },
  {
    type: 2,
    url:
      'https://mpv.videocc.net/722a1e202d/f/722a1e202d1d0cf92281f35707e5aedf_3.mp4',
  },
  {
    type: 1,
    url:
      'http://content-pic2-mirror.oss-cn-hangzhou.aliyuncs.com/1719884045551.png',
  },
];

import BaseURL from '../static/config';

export default {
  name: 'PPT',
  data() {
    return {
      index: 0,
      currentSource: {},
      showNext: true,
      showPre: false,
    };
  },

  mounted() {
    this.currentSource = allVideoImages[this.index];
    console.log('-----', BaseURL);
  },
  methods: {
    onNext() {
      if (this.index < allVideoImages.length - 1) {
        this.index = this.index + 1;
        this.currentSource = allVideoImages[this.index];
        this.showNext = this.index < allVideoImages.length - 1;
        this.showPre = this.index > 0;
      }
    },
    onPre() {
      if (this.index > 0) {
        this.index = this.index - 1;
        this.currentSource = allVideoImages[this.index];
        this.showNext = this.index < allVideoImages.length - 1;
        this.showPre = this.index > 0;
      }
    },
  },
};
</script>

<style scoped>
#content {
  width: 100vw;
  height: 100vh;
}

.image {
  width: 100vw;
  height: 100vh;
  object-fit: contain;
}

.source-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

button {
  background-color: #3f7eef;
  color: white;
  border: none;
  border-radius: 10px;
  height: 35px;
  width: 60px;
  margin-left: 10px;
}

.button-container {
  position: fixed;
  bottom: 0;
  z-index: 10000;
  width: 200px;
  height: 35px;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
